/**
 * Editor-descriptor keys an `editable:` declaration may carry besides the
 * field key, the column and the editor type. They are serialized into
 * `data-builder-options` so the runtime can hydrate an editor straight off the
 * DOM, with no `fields[]` manifest lookup.
 */
export const EDITOR_OPTION_KEYS = [
  'label', 'placeholder', 'options', 'bundles', 'vocabularies', 'objectType',
  'multiple', 'max', 'columns', 'addLabel', 'defaultItem', 'imageStyle',
  // Rich-text inline editing reads these off the descriptor (formats select +
  // default format). Mirrors what InlineRichTextEditor consumes.
  'formats', 'format', 'defaultFormat',
  // Dynamic-select (`es-select`, lot L3): options fetched from an endpoint at
  // edit time instead of a static `options:` list — keeps a block def portable
  // (no instance-specific values baked in). Consumed by DynamicSelectEditor.
  'optionsUrl', 'optionsPath', 'optionsValueKey', 'optionsLabelKey',
  // Intitulé du lien : un lien a deux réglages, son adresse et son texte. Le
  // texte vit dans un AUTRE champ — une cellule voisine de la ligne
  // (`labelColumn:`) ou un champ du bloc (`labelField:`) — que la pop-in du
  // type `link` édite en même temps que l'adresse. `labelTitle:` en règle le
  // libellé (défaut « Intitulé »).
  'labelField', 'labelColumn', 'labelTitle',
]

/** Pick the editor options present on an `editable:`-shaped object. */
export const pickEditorOptions = (source) => {
  const options = {}
  if (source == null || typeof source !== 'object') return options
  for (const key of EDITOR_OPTION_KEYS) {
    if (source[key] !== undefined) options[key] = source[key]
  }
  return options
}

/**
 * Picto et intitulé de repli d'un éditeur ouvert depuis un MENU — le rail de
 * ligne (`BuilderRowToolbar.edit`) comme le menu « Options avancées » du bloc
 * (`settings:`). Un `link`, une icône, un fond n'ont rien à cliquer DANS le
 * rendu : leur seule affordance est ce bouton, donc son picto doit nommer le
 * type à lui seul quand la déclaration n'en propose pas.
 */
export const EDITOR_ICONS = {
  link: 'Link',
  image: 'Image',
  'image-drupal': 'Image',
  'youtube-url': 'Youtube',
  icon: 'Star',
  select: 'List',
  background: 'Palette',
  'node-ref': 'FileText',
  'term-ref': 'Tag',
  'object-ref': 'Boxes',
  process: 'Workflow',
}

/** Intitulé de repli quand une déclaration ne porte pas de `label:`. */
export const EDITOR_TITLES = {
  link: 'Adresse du lien',
  image: 'Image',
  'image-drupal': 'Image',
  'youtube-url': 'Vidéo YouTube',
  icon: 'Icône',
  select: 'Choix',
  background: 'Fond',
  process: 'Processus',
}
